/**
 * Created by intellicar-rinas on 21/9/17.
 */

export default {

    singleSearch : {
        deBounceTime: 500, // ms,
        minLength: 3, // characters,
        // searchKeys: ['vehicleno', 'pgroupname', 'vehicleprefdata', 'TRACKER_deviceno', 'LOCK_UNLOCK_deviceno'],
        preProcessValues: [
            {from:'groups[].groupnamepath', to:'groupnames'},
            {from:'vehiclemeta.chassisno', to:'vehiclechassisno'},
            {from:'vehiclemeta.model', to:'vehiclemodel'},
        ],
        searchKeys: [
            'devicetype',
            'vehicleno',
            'vehiclemodel',
            'vehiclechassisno',
            'TRACKER_deviceno',
            'LOCK_UNLOCK_deviceno',
            'groupnames',
        ],
    }

}
